import moment from "moment";

export const socMedOptions = [
  { label: "ALL", value: "ALL" },
  { label: "ADA", value: "YES" },
  { label: "TIDAK ADA", value: "NO" },
];

export const prospekCategoryOptions = [
  { label: "H1", value: "H1" },
  { label: "H23", value: "H23" },
];

export const prospekTypeOptions = [
  { label: "NEW", value: "NEW" },
  { label: "RO H1", value: "RO_H1" },
  { label: "RO H23", value: "RO_H23" },
  { label: "XS H21", value: "XS_H21" },
  { label: "XS H21P", value: "XS_H21P" },
];

export const prospekSourceOptions = [
  { label: "CRM", value: "CRM" },
  { label: "Bengkel", value: "BENGKEL" },
  { label: "Service Visit", value: "SERVICE_VISIT" },
  { label: "Safety Check", value: "SAFETY_CHECK" },
  { label: "Pameran", value: "PAMERAN" },
  { label: "MedSos", value: "MEDSOS" },
];

export const operatorOptions = [
  { label: "<", value: "<" },
  { label: "<=", value: "<=" },
  { label: "=", value: "=" },
  { label: ">=", value: ">=" },
  { label: ">", value: ">" },
];

export const memberLevelOptions = [
  { label: "GOLD", value: "GOLD" },
  { label: "SILVER", value: "SILVER" },
];

export const loyaltyLevelOptions = [
  { label: "BUYER", value: "BUYER" },
  { label: "CUSTOMER", value: "CUSTOMER" },
  { label: "ADVOKAT", value: "ADVOCATE" },
];

export const specialCategoryOptions = [
  { label: null, value: "" },
  { label: "Pembawa", value: "PEMBAWA" },
  { label: "Makelar", value: "MAKELAR" },
  { label: "Affiliate", value: "AFFILIATE" },
];

export const fuStatus = [
  { label: "ONGOING", value: "ONGOING" },
  { label: "DEAL", value: "DEAL" },
  { label: "DROP", value: "DROP" },
  // {label: "DEAL", value: "DEAL"},
  { label: "DEATH", value: "DEATH" },
  // {label: "INDENT", value: "INDENT"},
];

export const fuBy = [
  { label: "TELEPON", value: "TELEPON" },
  { label: "WA CALL", value: "WA_CALL" },
  { label: "WA CHAT", value: "WA_CHAT" },
  { label: "VISIT", value: "VISIT" },
  { label: "MEDSOS", value: "MEDSOS" },
];

export const connected = [
  { label: "YES", value: true },
  { label: "NO", value: false },
];

export const TABS = {
  NON_FOLLOW_UP: "NON FOLLOW UP",
  ONGOING: "ONGOING",
  DROP: "DROP",
  DEATH: "DEATH",
  DEAL: "DEAL",
};

export const FU_STATUS = [
  { label: "ONGOING", value: "ONGOING" },
  { label: "DEAL", value: "DEAL" },
  { label: "DROP", value: "DROP" },
  { label: "DEATH", value: "DEATH" },
];

export const FU_BY = [
  { label: "TELEPON", value: "TELEPON" },
  { label: "WA CALL", value: "WA_CALL" },
  { label: "WA CHAT", value: "WA_CHAT" },
  { label: "VISIT", value: "VISIT" },
  { label: "MEDSOS", value: "MEDSOS" },
];

export const CONNECTED = [
  { label: "YES", value: true },
  { label: "NO", value: false },
];

export const INITIAL_PAGINATION = {
  limit: 5,
  page: 1,
  totalData: 0,
};

export const INITIAL_DATE = moment().format("DD-MM-YYYY");

export const INITIAL_ERRORS = {
  followUpStatus: null,
  followUpMethod: null,
  connected: null,
  nextAppointmentDate: null,
  followUpResult: null,
  cancelReason: null
};

export const defaultFilter = {
  tanggalProspek: {
    tanggalAwal: null,
    tanggalAkhir: null,
  },
  fuDate: {
    tanggalAwal: null,
    tanggalAkhir: null,
  },
  appointmentDate: {
    tanggalAwal: null,
    tanggalAkhir: null,
  },
  operator: null,
  comparator: null,
  overdue: null,
  prospectCategory: null,
  prospectKind: null,
  prospectSource: null,
  province: null,
  kabkot: null,
  kecamatan: null,
  kelurahan: null,
  kodePos: null,
  memberLevel: null,
  loyaltyLevel: null,
  facebook: null,
  instagram: null,
  linkedin: null,
  x: null,
  tiktok: null,
  hobby: [],
  interest: [],
  kodeCabang: null,
  prospectName: null,
  sourceCabang: null,
  ownerProspect: null,
  lastSeller: null,
  status: null,
  lastFollowUpBy: null,
  information: null,
  nama: null,
  nik: null,
  handPhoneNumber: null,
  handPhoneNumber2: null,
  alamat: null,
  lastFollowUpStatus: null,
  memberId: null,
};

export const formGroup = {
  name: { value: null, mandatory: true },
  nik: { value: null, mandatory: true },
  address: { value: null, mandatory: true },
  provinceId: { value: null, mandatory: true },
  kabkotId: { value: null, mandatory: true },
  kecamatanId: { value: null, mandatory: true },
  kelurahanId: { value: null, mandatory: true },
  zipcode: { value: null, mandatory: true },
  gender: { value: null, mandatory: true },
  job1: { value: null, mandatory: true },
  job2: { value: null },
  religion: { value: null, mandatory: true },
  hpNumber1: { value: null, mandatory: true },
  hpNumber2: { value: null },
  email: { value: null, mandatory: true },
  facebook: { value: null },
  instagram: { value: null },
  linkedin: { value: null },
  twitter: { value: null },
  tiktok: { value: null },
  discCategory: { value: null },
  hobby: { value: [] },
  interest: { value: [] },
  customerId: { value: null },
  memberLevel: { value: null },
  loyaltyLevel: { value: null },
  specialCategory: { value: null },
  specialNotes: { value: null },
  photoCustomerUrl: { value: null },
  kodeCabang: { value: null },
  prospectDate: { value: null },
  prospectId: { value: null },
  category: { value: prospekCategoryOptions[1]},
  source: { value: null, mandatory: true },
  sourceCabang: { value: null },
  lastFollowUpBy: { value: null },
  type: { value: null },
  prospectOwnership: { value: null },
  lastSeller: { value: null },
  tanggalServiceTerakhir: { value: null },
};

export const NOT_REQUIRED_STATUS = ["DROP", "DEATH"];

export const FOLLOWUP_STATUS = ["NON_FOLLOW_UP", "ONGOING"];

export const DELETE_STATUS = ["ONGOING"];
